export const timeFormat = 'HH:mm';
export const dateFormat = 'DD.MM.YYYY';
export const dateAndTimeFormat = 'DD.MM.YYYY - HH:mm';
export const dateFormatCompare = 'DD-MM-YYYY';
export const timeFormatCompare = 'HH:mm';

/* 
Info:
- 7:20 - 8:20 - 2-12 years and upper 12 years
- first block end on 11:50 
- +30min breacks
- second block start on 13:30 - 14:00 
- second block end on ~17:25
- length of the school day ~6 hour with breacks
*/
export const LENGHT_SCHOOL_DAY = '5:30'; // - 30 min breacks
export const START_YEAR = '21-08'; // dd.mm - curernt year
export const END_1_SEMESTER = '08-01'; // dd.mm - curernt year
export const START_2_SEMESTER = '11-01'; // dd.mm - +1 year
export const END_YEAR = '24-06'; // dd.mm - +1 year